"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { observer } from "mobx-react-lite";
import store from "@/store/store";
import { AppState } from "@/types/enums";
import {
    initMatomo,
    parseCustomerDepartmentFromPath,
    trackEvent,
    trackPageView,
} from "../../lib/matomo";

const screenByState: Record<AppState, string> = {
    [AppState.START]: "start",
    [AppState.COUNTDOWN]: "countdown",
    [AppState.QUESTION]: "question",
    [AppState.END]: "end",
};

const MatomoBootstrap = observer(function MatomoBootstrap() {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        initMatomo();
    }, []);

    useEffect(() => {
        if (!pathname) return;
        const query = searchParams?.toString();
        const fullPath = query ? `${pathname}?${query}` : pathname;
        const parsed = parseCustomerDepartmentFromPath(pathname);

        trackPageView({
            path: fullPath,
            title: document.title,
            context: {
                customer: parsed.customer,
                department: parsed.department,
                screen: screenByState[store.currentState],
            },
        });
    }, [pathname, searchParams, store.currentState]);

    useEffect(() => {
        trackEvent({
            category: "Quiz",
            action: "screen_view",
            name: screenByState[store.currentState],
            context: {
                customer: store.customerSlug,
                department: store.department,
                screen: screenByState[store.currentState],
            },
        });
    }, [store.currentState, store.customerSlug, store.department]);

    return null;
});

export default MatomoBootstrap;
